import React from 'react';
import { Dealer } from '../../../models/dealer';
import searchStateContext from '../../../contexts/map-context';

export const DEFAULT_NR_OF_RESULTS = 7;
const DEFAULT_DISPLAY_RESULTS_INDEX = 0;

const getResults = (results: Dealer[], displayResultsIndex: number) => {
  if (results.length <= DEFAULT_NR_OF_RESULTS) return results;

  return results.slice(0, displayResultsIndex + DEFAULT_NR_OF_RESULTS);
};

export const useDisplayResults = (): [Dealer[], () => void] => {
  const [displayResultsIndex, setDisplayResultsIndex] = React.useState(
    DEFAULT_DISPLAY_RESULTS_INDEX,
  );
  const { results } = searchStateContext.useMapState();

  const displayResult = getResults(results || [], displayResultsIndex);

  React.useEffect(() => {
    setDisplayResultsIndex(DEFAULT_DISPLAY_RESULTS_INDEX);
  }, [results]);

  return [displayResult, () => setDisplayResultsIndex(displayResultsIndex + DEFAULT_NR_OF_RESULTS)];
};
